<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :stripe="false"
      search-btn-hide
      right-toolbar-hide
      row-key="id"
      :reset-data="resetDataFn"
      lazy
      :load="loadMethod"
      :row-style="$treeRowStyleFun"
      @handleSelectionChange="handleSelectionChange"
      @afterFetchData="handleAfterFetchData"
    >
      <template v-slot:baseForm> </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="left"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />

              <span v-else-if="col.prop === 'skuName'">
                <el-tag v-if="scope.row.giftFlag">{{ $t('SourcingDetails.form.Gift') }}</el-tag> {{ scope.row.skuName }}</span
              >
              <span v-else-if="col.prop === 'skuNum'">
                {{ scope.row.skuNum }}{{ scope.row.num }}</span
              >

              <span v-else-if="col.prop === 'sourcingStatus' && scope.row.BJ_HAS_CHILD">
                {{ $t(ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(scope.row.sourcingStatus)) }}</span
              >
              <span v-else-if="col.prop === 'sourcingStatus' && !scope.row.BJ_HAS_CHILD">
                {{ $t(ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(scope.row[col.prop])) }}</span
              >

              <template v-else-if="col.prop === 'other'">
                <div v-if="!scope.row.BJ_HAS_CHILD">
                  <!-- <span class="table-other-td-item">
                    是否赠品：{{ $t(STATUS_YES_NUM.bjGet(scope.row.giftFlag)) }}</span
                  > -->
                  <span class="table-other-td-item">
                    {{ $t('SourcingDetails.form.warehouse') }} : {{ scope.row.stockWarehouseCode }}</span
                  >
                  <span class="table-other-td-item">
                    {{ $t('SourcingDetails.form.Shipment') }} :  {{ scope.row.stockWarehouseName }}</span
                  >
                  <span class="table-other-td-item"> {{ $t('SourcingDetails.form.Failure') }} : {{ scope.row.failReason }}</span>
                </div>
              </template>

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="onDetail(scope.row)">{{ $t('viewText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
      <template v-slot:paginationLeft>
        <span>{{ $t('SourcingDetails.form.Total') }} {{ resNumberOfElements }}</span>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import { STATUS_YES_NUM, ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST } from '@/utils/constants';

export default {
  name: 'BusinessOrderPreemptDetailSkuList',
  components: {},
  mixins: [pageMiXin],
  // eslint-disable-next-line vue/require-prop-types
  props: ['orderId', 'hasBtn'],
  data() {
    return {
      selection: false,
      serial: true,
      sortTableByOptionName: true,
      STATUS_YES_NUM,
      ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,
      queryApi: orderApi.getOrderSourcingSkuListByOrder,

      // 查询参数
      queryParams: {
        sourcingId: null,
      },
      labelList: [
        // #ifndef OPEN-SOURCE
        { label: this.$t('SourcingDetails.form.status'), prop: 'sourcingStatus', isCheck: true, disabled: false },
        // #endif
        // { label: this.$t('goodsPage.spuName'), prop: 'spuName', isCheck: true, disabled: false },
        // { label: this.$t('goodsPage.spuCode'), prop: 'spuCode', isCheck: true, disabled: false },
        { label: this.$t('SourcingDetails.form.SKU'), prop: 'skuName', isCheck: true, disabled: false },
        { label: this.$t('SourcingDetails.form.SKUcode'), prop: 'skuCode', isCheck: true, disabled: false },
        { label: this.$t('SourcingDetails.form.quantity'), prop: 'skuNum', isCheck: true, disabled: false },

        { label: this.$t('SourcingDetails.form.Other'), prop: 'other', isCheck: true, disabled: false },
        // { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 129},
      ],
      selectedRows: null,
      resNumberOfElements: null,
    };
  },
  watch: {},
  created() {
    this.queryParams.sourcingId = this.orderId;
  },
  methods: {
    // 改造主表API返回值，加入空的子表数据
    resetDataFn(data) {
      return data.map(e => {
        return { BJ_HAS_CHILD: true, BJ_PARENT_ID: null, ...e };
      });
    },
    handleAfterFetchData(res) {
      this.resNumberOfElements = res.numberOfElements || 0;
    },
    loadMethod({ row }) {
      // 异步加载子节点
      return new Promise((resolve, reject) => {
        orderApi
          .getOrderSourcingSkuLineListBySku({
            sourcingId: this.orderId,
            skuCode: row.skuCode,
          })
          .then(res => {
            const TEMP = (Array.isArray(res) ? res : []).map(e => {
              return { ...e, BJ_HAS_CHILD: false, BJ_PARENT_ID: row.id };
            });

            if (TEMP.length) {
              resolve(TEMP);
            } else {
              this.$message.warning(this.$t('SourcingDetails.form.returned'));
              reject();
            }
          });
      });
    },
    onSkuLineLog() {},
  },
};
</script>
